<template>
  <div class="lean-is-published">
    <v-icon v-if="publishStatus === 2" color="green darken-3"> mdi-eye </v-icon>
    <v-icon v-if="publishStatus === 1" color="yellow darken-3"> mdi-eye </v-icon>
    <v-icon v-if="publishStatus === 0" color="grey lighten-1"> mdi-eye-off </v-icon>
  </div>
</template>
<script>
export default {
  name: 'lean-is-published',
  data: function () {
    return {
      publishStatus: 0
    };
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  watch: {
    record: {
      async handler(record) {
        let status = 0;
        const currentVersionId = record?.version;
        const publishedVersionId = (record?.destinationmetadata?.tags ?? []).find((tag) => tag.Key === 'srcVersionId')
          ?.Value;
        if (publishedVersionId === currentVersionId) {
          status = 2;
        } else if (publishedVersionId) {
          status = 1;
        }
        this.publishStatus = status;
      },
      immediate: true
    }
  }
};
</script>
